import React, { useState } from 'react';
import { TextField, Button, Typography, Container, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff, EmailOutlined, LockOutlined, VpnKeyOutlined } from '@mui/icons-material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [twoFactorCode, setTwoFactorCode] = useState('');
  const [step, setStep] = useState('login'); 
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleLogin = async () => {
    try {
      await axios.post(`${API_BASE_URL}/api/login`, { email, password });
      localStorage.setItem('email', JSON.stringify(email));
      setStep('verify');
    } catch (error) {
      setError('Login failed: ' + (error.response?.data?.msg || error.message));
    }
  };

  const handleVerify = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/verify-2fa`, { email, twoFactorCode });
      const { token} = response.data; // assuming the response includes the user data
      localStorage.setItem('token', token);
      navigate('/profile'); // Navigate to Profile page 
    } catch (error) {
      setError('2FA verification failed: ' + (error.response?.data?.msg || error.message));
    }
  };

  const handleForgotPassword = () => {
    navigate('/forgot-password');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#342F49] px-4 relative">
      <button
        className="absolute top-6 left-6 flex items-center text-[#66C5CC] font-semibold hover:underline bg-[#231E3D] px-3 py-2 rounded-lg shadow"
        onClick={() => navigate('/')}
        style={{ zIndex: 10 }}
      >
        <span className="mr-2">←</span> Home
      </button>
      <div className="w-full max-w-md bg-[#231E3D] rounded-2xl shadow-2xl p-8 sm:p-10 border border-[#66C5CC]">
        <h2 className="text-3xl font-bold text-center text-[#66C5CC] mb-8">Sign In to GreenMines</h2>
        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="block text-[#66C5CC] mb-2 font-semibold">Email</label>
            <input
              type="email"
              className="w-full px-4 py-3 rounded-lg bg-[#2E2E2E] text-white border border-[#66C5CC] focus:outline-none focus:ring-2 focus:ring-[#66C5CC]"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              autoComplete="email"
            />
          </div>
          <div>
            <label className="block text-[#66C5CC] mb-2 font-semibold">Password</label>
            <input
              type="password"
              className="w-full px-4 py-3 rounded-lg bg-[#2E2E2E] text-white border border-[#66C5CC] focus:outline-none focus:ring-2 focus:ring-[#66C5CC]"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              autoComplete="current-password"
            />
          </div>
          {error && <div className="text-red-400 text-center font-semibold">{error}</div>}
          <button
            type="submit"
            className="w-full py-3 rounded-lg bg-[#66C5CC] text-[#231E3D] font-bold text-lg hover:bg-[#4da5aa] transition"
          >
            Sign In
          </button>
        </form>
        <div className="mt-6 text-center">
          <span className="text-gray-400">Don't have an account? </span>
          <button
            className="text-[#66C5CC] font-semibold hover:underline"
            onClick={() => navigate('/register')}
          >
            Sign Up
          </button>
        </div>
      </div>
    </div>
  );
}

export default Login;
